module.exports = __webpack_public_path__ + "static/media/openlite-wordpress-white.cc016e19.svg";